<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listFunctions"
        :title-table="$t('Functions')"
        module="functionsSettingsModule"
        sort-name="nome"
        add-permission="ROLE_FUNCAO_INSERIR"
        view-permission="ROLE_FUNCAO_CONSULTAR"
        edit-permission="ROLE_FUNCAO_ATUALIZAR"
        delete-permission="ROLE_FUNCAO_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormFunctions v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import FormFunctions from "./forms/FormFunctions.vue";

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormFunctions,
  },
  computed: {
    ...mapState("functionsSettingsModule", {
      listFunctions: (state) => state.listFunctions,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: "Id",
          field: "id",
        },
        {
          label: "Descrição",
          field: "nome",
        },
        {
          label: "Ativo",
          field: "ativo",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch(
        "functionsSettingsModule/prepareToEditFunction",
        data,
      );
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
